import Icon from '../components/Icon.vue'

Icon.register({
  'user-shield': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M622.3 271.1c10.7 4.2 17.7 14 17.7 24.9 0 124.5-81.6 193.9-132.9 213.9-4.2 1.6-12.6 3.7-22.2 0-64.2-25.1-132.9-102.3-132.9-213.9 0-10.9 7-20.7 17.7-24.9l115.2-45c9.6-3.7 18.1-1.6 22.2 0zM496 462.4c34.6-16.4 89.9-64.7 95.5-151.8l-95.5-37.3v189.1zM224 256c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128-57.3 128-128 128zM320 296c0 95.3 45.2 169.1 99.2 212-5.9 2.5-12.4 4-19.2 4h-352c-26.5 0-48-21.5-48-48v-41.6c0-74.2 60.2-134.4 134.4-134.4h16.7c22.3 10.2 46.9 16 72.9 16s50.7-5.8 72.9-16h16.7c2.6 0 5 0.7 7.5 0.8-0.3 2.4-1.1 4.7-1.1 7.2z'
      }
    ]
  }
})
